



















































































































import { mapActions, mapState, mapGetters } from 'vuex'
import { sleep } from 'plankton/lib/test'
import HintWithTooltip from '@/components/HintWithTooltip.vue'

export default {
  components: { HintWithTooltip },
  props: {
    transportId: { type: Number, required: true },
    transportRequest: { type: Object, required: true },
    title: { type: String, default: '' },
    allowedVehicleTypes: { type: Array, required: true }
  },
  data() {
    return {
      licensePlate: '',
      trailerLicensePlate: '',
      driverPhoneNumber: '',
      driverName: '',
      licensePlateAlreadySet: false,
      isLicensePlateInfoSaving: false,
      isFormEditable: true,
      vehicleType: '',
      order: null,
      vehicleDropdownOpenDirection: 'bottom'
    }
  },
  computed: {
    ...mapState(['vehicleTypes']),
    ...mapGetters(['transportOrder']),
    submitButtonLabel() {
      if (this.isLicensePlateInfoSaving) {
        return `${this.$t('myTransports.transportDetails.transportDetailForm.saving')}...`
      } else if (this.licensePlateAlreadySet) {
        return this.$t('myTransports.transportDetails.transportDetailForm.saveChanges')
      } else {
        return this.$t('myTransports.transportDetails.transportDetailForm.confirmDetails')
      }
    },
    inputColumnSpan() {
      return 24 / 6
    },
    tooltipText() {
      return this.$t(
        'myTransports.transportDetails.transportDetailForm.vehicleTypesContact',
        { email: this.order && (this.order.operator || this.order.accountManager) }
      )
    },
    isOnlyOneVehicleAllowed() {
      return this.allowedVehicleTypesList.length === 1
    },
    allowedVehicleTypesList() {
      return this.allowedVehicleTypes
        .map(type => ({
          value: type,
          label: this.vehicleTypes[type]
        }))
        .sort()
    }
  },
  created() {
    this.order = this.transportOrder
    this.vehicleType = this.findDefaultVehicleType(this.allowedVehicleTypesList)
    if (this.transportRequest && this.transportRequest.licensePlate) {
      this.licensePlateAlreadySet = true
      this.licensePlate = this.transportRequest.licensePlate
      this.trailerLicensePlate = this.transportRequest.trailerLicensePlate
      this.driverName = this.transportRequest.driverName
      this.driverPhoneNumber = this.transportRequest.driverPhoneNumber
    }
    if (this.isOnlyOneVehicleAllowed && !this.vehicleType) {
      this.vehicleType = this.allowedVehicleTypesList[0]
    }
    this.isFormEditable = this.transportRequest.isEditableByCarrier
  },
  mounted() {
    this.setDropdownOpenDirection()
  },
  methods: {
    ...mapActions(['saveLicensePlateInfo']),
    formatLicensePlates() {
      const {
        trailerLicensePlate,
        licensePlate,
        formatLicenceWithDigitsAndLetters
      } = this
      // removes every symbol that is not a letter or a digit
      this.licensePlate = formatLicenceWithDigitsAndLetters(licensePlate)
      this.trailerLicensePlate =
        trailerLicensePlate && formatLicenceWithDigitsAndLetters(trailerLicensePlate)
    },
    formatLicenceWithDigitsAndLetters(item) {
      return item.toUpperCase().replace(/[^A-Z0-9]+/g, '')
    },
    findDefaultVehicleType(items) {
      const vehicleType = this.order && this.order.vehicleType
      return items.find(item => item.value === vehicleType)
    },
    setDropdownOpenDirection() {
      const distanceToDocumentBottom =
        window.innerHeight - this.$refs.vehicleTypesDropdown.getBoundingClientRect().top
      if (distanceToDocumentBottom < 200) {
        this.vehicleDropdownOpenDirection = 'top'
      } else {
        this.vehicleDropdownOpenDirection = 'bottom'
      }
    },
    async handleSubmit() {
      this.formatLicensePlates()
      this.isLicensePlateInfoSaving = true
      // waiting for backend response but not less than a second (to make user see the loading state)
      try {
        await Promise.all([
          sleep(1000),
          this.saveLicensePlateInfo({
            transportId: this.transportId,
            vehicleLicense: this.licensePlate,
            trailerLicense: this.trailerLicensePlate,
            driver: this.driverName,
            driverPhoneNumber: this.driverPhoneNumber,
            vehicleType: this.vehicleType ? this.vehicleType.value : ''
          })
        ])
      } finally {
        this.isLicensePlateInfoSaving = false
        this.licensePlateAlreadySet = true
      }
    }
  }
}
